import { Navigate, useLocation } from "react-router-dom";

import { AuthPaths } from "routes/paths";
import React from "react";
import { getDecodedJwt, isAuthenticated } from "utils/auth";
import { useDecodedUser } from "contexts/DecodedUser";

const AuthGuard = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const { data, setDecodedUser } = useDecodedUser();
  if (isAuthenticated()) {
    if (!data) {
      setDecodedUser(getDecodedJwt());
    }
    return <>{children}</>;
  }
  return <Navigate to={AuthPaths.SIGNIN} state={{ from: location }} replace />;
};

export default AuthGuard;
